import * as React from 'react';
import { FC } from 'react';

import { useNavigate } from 'react-router-dom';

import { useFeaturesLoyaltyShortCodeConfirmationModal } from 'pages/loyalty/loyalty-short-code-confirmation-modal/use-feature-loyalty-short-code-confirmation-modal';

import LoyaltyShortCodeConfirmationModalView from './loyalty-short-code-confirmation-modal.view';

interface LoyaltyShortCodeConfirmationModalProps {
  onAction?: () => void;
}

const LoyaltyShortCodeConfirmationModal: FC<LoyaltyShortCodeConfirmationModalProps> = ({
  onAction,
}) => {
  const navigate = useNavigate();
  const { data, loading } = useFeaturesLoyaltyShortCodeConfirmationModal();
  const { actionButton, body, header, image } = data?.shortCodeConfirmationModalContent || {};
  const parsedImage = image?.locale?.app;

  const handleAction = () => {
    if (onAction) {
      onAction();
    }
    navigate(actionButton?.buttonPath?.locale || '');
  };

  if (loading || !data || !parsedImage) {
    return null;
  }

  return (
    <LoyaltyShortCodeConfirmationModalView
      actionText={actionButton?.buttonText?.locale || ''}
      bodyText={body?.locale || ''}
      handleAction={handleAction}
      headerText={header?.locale || ''}
      image={parsedImage}
    />
  );
};

export default LoyaltyShortCodeConfirmationModal;
